import { PackSettings } from '../../../models';
import { Guid } from '../../../shared/utils';

export const DEFAULT_PACK_TOTAL_MINUTES = 10 * 60;
export const DEFAULT_PACK_TOTAL_CREDITS = 10;
export const DEFAULT_PACK_CREDITS_PER_APPOINTMENT = 1;
export const DEFAULT_PACK_VALIDITY_DAYS = 12 * 30;

export const createDefaultPackSettings = (): PackSettings => ({
    id: Guid.newGuid(),
    name: '',
    version: 1,
    appointmentTypes: [],
    creationDate: new Date().toISOString(),
    price: 0,
    validityDays: DEFAULT_PACK_VALIDITY_DAYS,
    totalMinutes: DEFAULT_PACK_TOTAL_MINUTES,
});

export const withDefaultCreditsForAppointmentTypes = (
    appointmentTypes: string[],
    appointmentTypesCredits?: Record<string, number>,
): Record<string, number> => Object.fromEntries(
    appointmentTypes.map(type => [
        type,
        appointmentTypesCredits?.[type] ?? DEFAULT_PACK_CREDITS_PER_APPOINTMENT,
    ]),
);
